module.exports = __webpack_public_path__ + "img/xbox-2.25ce181e.png";